/**
 * Microsoft Authentication Provider
 *
 * Previously wrapped the app with MSAL context. Now that Microsoft auth
 * is handled server-side (backend token exchange), this is a simple
 * pass-through to avoid breaking the component tree in App.tsx.
 */

interface MicrosoftAuthProviderProps {
  children: React.ReactNode;
}

export function MicrosoftAuthProvider({ children }: MicrosoftAuthProviderProps) {
  return <>{children}</>;
}

export function useMicrosoftAuthReady(): boolean {
  return true;
}
